import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTimeline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.1666 10.6667C10.8904 10.6667 10.6666 10.4428 10.6666 10.1667V7.375C10.6666 7.09886 10.8904 6.875 11.1666 6.875H12.8333C13.1094 6.875 13.3333 7.09886 13.3333 7.375V10.1667C13.3333 10.4428 13.1094 10.6667 12.8333 10.6667H11.1666ZM7.16659 10.6667C6.89044 10.6667 6.66658 10.4428 6.66658 10.1667V2.5C6.66658 2.22386 6.89044 2 7.16658 2H8.83325C9.10939 2 9.33325 2.22386 9.33325 2.5V10.1667C9.33325 10.4428 9.10939 10.6667 8.83325 10.6667H7.16659ZM3.16659 10.6667C2.89044 10.6667 2.66659 10.4428 2.66659 10.1667V5.20833C2.66659 4.93219 2.89044 4.70833 3.16659 4.70833H4.83325C5.10939 4.70833 5.33325 4.93219 5.33325 5.20833V10.1667C5.33325 10.4428 5.10939 10.6667 4.83325 10.6667H3.16659ZM12.8333 13.3333V13.9238C12.8333 14.1547 13.0833 14.299 13.2833 14.1836L14.8833 13.2598C15.0833 13.1443 15.0833 12.8557 14.8833 12.7402L13.2833 11.8164C13.0833 11.701 12.8333 11.8453 12.8333 12.0762V12.6667H1.33325V13.3333H12.8333Z"
	})
});
export default SvgTimeline;
